import type { ResolvedView } from '@hibro/shared';

/**
 * Resolve a boot-time product value to a live editor contribution. Product
 * configuration is intentionally fail-closed: unknown, non-string, and
 * non-editor targets preserve the workbench empty state.
 */
export function resolveStartupEditorView(
  configuredViewId: unknown,
  views: readonly ResolvedView[],
): ResolvedView | undefined {
  if (typeof configuredViewId !== 'string') {
    return undefined;
  }
  const viewId = configuredViewId.trim();
  if (!viewId) {
    return undefined;
  }
  return views.find((view) => view.id === viewId && view.area === 'editor');
}
